import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useReactToPrint } from "react-to-print"
import { StatusItem } from "./StatusItem"
import openIcon from "./selecticon.png"
import "./style/style.css"
import { useDeviceStatusQuery } from "../../store/Features/devices/devicesStatus-api-slice"

import { SkeletonLoader } from "components"
import { NoDataFound } from "components"
import { useSelector } from "react-redux"
import { ISelectedDeviceIds } from "@types"

export const Status = () => {
 // language translator
 const { t } = useTranslation("translation")
 const [startIndex, setStartIndex] = useState(0)
 const componentRef = useRef(null)
 const { data, isLoading } = useDeviceStatusQuery()
 const selectedDevice: ISelectedDeviceIds = useSelector((state: any) => state.selectedDevicesIds)

 const filteredArray: any = data?.filter(
  (obj: any) => selectedDevice.deviceIds?.includes(obj.device_id),
 )

 const cardsPerPage = 3
 // splitting array
 const Allcards = filteredArray?.slice(startIndex, startIndex + cardsPerPage)

 const handleNext = () => {
  if (startIndex + cardsPerPage < filteredArray?.length) {
   setStartIndex(startIndex + cardsPerPage)
  }
 }

 const handlePrev = () => {
  if (startIndex - cardsPerPage >= 0) {
   setStartIndex(startIndex - cardsPerPage)
  }
 }

 // method for printing the devices status
 const handlePrint = useReactToPrint({
  content: () => componentRef.current,
 })

 return (
  <div>
   <div className="flex justify-between items-center w-[98%] mx-auto py-4 px-2.5 lg:px-0">
    <h1 className="font-semibold text-2xl">{t("PlantStatus")}</h1>
    <div className="flex justify-between items-center lg:w-[18%]">
     <button
      className="bg-dark-yellow px-6 py-1 font-semibold  rounded hover:bg-[#FED749] hover:text-white "
      onClick={() => {
       handlePrint()
      }}
     >
      {t("print")}
     </button>
     <div className="flex lg:w-[35%]  justify-between">
      <button
       onClick={handlePrev}
       disabled={startIndex === 0}
       className={`bg-white h-6 w-6 rounded-lg flex items-center justify-center mx-2 lg:mx-0 ${
        startIndex === 0 ? "opacity-40" : ""
       }`}
      >
       <img className="rotate-[-90deg]" src={openIcon} alt="prev" />
      </button>
      <button
       disabled={startIndex + cardsPerPage >= filteredArray?.length}
       onClick={handleNext}
       className={`bg-white h-6 w-6 rounded-lg flex items-center justify-center ${
        startIndex + cardsPerPage >= filteredArray?.length ? "opacity-40" : ""
       }`}
      >
       <img className="rotate-90" src={openIcon} alt="next" />
      </button>
     </div>
    </div>
   </div>

   <div
    ref={componentRef}
    className="flex lg:flex-row flex-col gap-3 overflow-x-scroll hide-scroll-icon"
   >
    {isLoading ? (
     <div className="w-[98%] mx-auto">
      <SkeletonLoader count={6} />
     </div>
    ) : Allcards?.length ? (
     Allcards.map((item: any, index: any) => (
      <div key={index} className="min-w-[45%] ">
       {/* =========== StatusItem component for removing duplicates ====== */}
       <StatusItem item={item} index={index} />
      </div>
     ))
    ) : (
     <NoDataFound />
    )}
   </div>
  </div>
 )
}
